<template>
	<div class="m-recommend">
		<div class="m-recommend-head flex-center">
			<h1>为您推荐</h1>
		</div>
		<div class="m-recommend-content">
			<ul class="tab-list flex-around-center">
				<li class="z-crt">{{unitData.tab_name}}</li>
				<li v-for="(item, i) in unitData.tabs" :key="i">{{item.tab_name}}</li>
			</ul>
			<div class="product-list flex-wrap">
				<a v-for="(item, i) in unitData.product_list" :key="item.product_id" class="item">
					<sub-image class="image" :src="item.product_img_url"></sub-image>
					<div class="info">
						<p class="name ellipsis-2">{{item.product_name}}</p>
						<div class="price">￥{{item.sale_price}}</div>
					</div>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {}
			}
		},
		
		mounted() {
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	.m-recommend {
		margin: 10px 0 30px;
		
		&-head {
			height: 88px;
			
			h1 {
				font-size: 24px;
			}
		}
		
		&-content {
			background: #fff;
			
			.tab-list {
				z-index: 1;
				position: sticky;
				top: 0;
				height: 90px;
				background: #fff;
				
				li {
					border-radius: 18px;
					padding: 0 24px;
					line-height: 36px;
					font-size: 16px;
					cursor: pointer;
					
					&.z-crt {
						color: #fff;
						background: #000;
					}
				}
			}
			
			.product-list {
				padding: 0 20px 20px;
				
				.item {
					box-sizing: border-box;
					width: 250px;
					border: 1px solid #eee;
					margin-left: 26px;
					
					&:nth-child(5n+1) {
						margin-left: 0;
					}
					
					&:nth-child(n+6) {
						margin-top: 28px;
					}
					
					.image {
						height: 248px;
						background: #F7F7F7;
					}
					
					.info {
						padding: 8px 14px 0;
						
						.name {
							height: 40px;
							line-height: 20px;
							font-size: 13px;
							color: #444;
						}
						
						.price {
							line-height: 55px;
							font-size: 16px;
							font-weight: bold;
						}
					}
				}
			}
		}
	}
</style>
